export default __webpack_public_path__ + "e0a300131f189fc30d21fb31283f083c.svg";